<div class="h-100 overflow-auto">
  <div class="col px-5">
    <div class="d-flex align-items-bottom">
      <div>
        <h3 class="everheader my-4">Update My Details</h3>
        <p>
          You can change your details here. Click on Save once the changes are
          made.
        </p>
      </div>
      <div class="ml-auto">
        <mat-card-header class="p-0">
          <div mat-card-avatar class="header-image"></div>
        </mat-card-header>
      </div>
    </div>
  </div>
  <div class="bgcomp d-flex flex-wrap mx-5">
    <div class="col my-3 mx-3">
      <div class="mt-3">
        <form [formGroup]="userDetailsFormGroup">
          <div class="row section">
            <div class="col-2">
              <h4 class="form-label mt-3">Display Name</h4>
            </div>
            <div class="col">
              <div class="d-flex mt-3">
                <div>
                  <mat-form-field class="editor title-field">
                    <mat-label>Title</mat-label>
                    <mat-select
                      formControlName="title"
                      id="title"
                      [panelWidth]="null"
                    >
                      <mat-option></mat-option>
                      <mat-option
                        *ngFor="let title of titles"
                        [value]="title.value"
                      >
                        {{ title.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="mx-sm-3">
                  <mat-form-field class="editor">
                    <mat-label>First Name</mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="firstName"
                      id="firstName"
                      required
                    />
                    <mat-error
                      *ngIf="
                        userDetailsForm.firstName.invalid &&
                        (userDetailsForm.firstName.dirty ||
                          userDetailsForm.firstName.touched)
                      "
                      class="invalid-feedback"
                    >
                      <div *ngIf="userDetailsForm.firstName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="userDetailsForm.firstName.errors.maxlength">
                        Name must be no more than 64 characters long.
                      </div>
                      <div *ngIf="userDetailsForm.firstName.errors.pattern">
                        Invalid characters in the name.
                      </div>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field class="editor">
                    <mat-label>Last Name</mat-label>
                    <input
                      type="text"
                      matInput
                      formControlName="lastName"
                      id="lastName"
                      required
                    />
                    <mat-error
                      *ngIf="
                        userDetailsForm.lastName.invalid &&
                        (userDetailsForm.lastName.dirty ||
                          userDetailsForm.lastName.touched)
                      "
                      class="invalid-feedback"
                    >
                      <div *ngIf="userDetailsForm.lastName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="userDetailsForm.lastName.errors.maxlength">
                        Name must be no more than 64 characters long.
                      </div>
                      <div *ngIf="userDetailsForm.lastName.errors.pattern">
                        Invalid characters in the name.
                      </div>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row section mt-3">
            <div class="col-2">
              <h4 class="form-label mt-3">Email Address</h4>
            </div>
            <div class="col">
              <div class="mt-3">
                <div class="mb-1">
                  <mat-form-field class="email-input-field">
                    <mat-label>Email Address</mat-label>
                    <input
                      type="email"
                      matInput
                      formControlName="emailAddress"
                      id="emailAddress"
                      [disabled]="true"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row section mt-3">
            <div class="col-2">
              <h4 class="form-label mt-3">Contact Number</h4>
            </div>
            <div class="col">
              <div class="d-flex align-items-start mt-3">
                <mat-form-field class="editor-phone">
                  <mat-label>Phone</mat-label>
                  <input
                    type="tel"
                    matInput
                    formControlName="contactPhone"
                    id="contactPhone"
                  />
                  <span class="editor-phone-countrycode mr-1" matTextPrefix>{{
                    countryCode
                  }}</span>
                  <mat-error
                    class="invalid-feedback"
                    *ngIf="
                      userDetailsForm.contactPhone.invalid &&
                      (userDetailsForm.contactPhone.dirty ||
                        userDetailsForm.contactPhone.touched)
                    "
                  >
                    <div *ngIf="userDetailsForm.contactPhone.errors.required">
                      Phone Number is required.
                    </div>
                    <div *ngIf="userDetailsForm.contactPhone.errors.pattern">
                      Only digits are accepted for phone numbers. Please retry.
                    </div>
                    <div *ngIf="userDetailsForm.contactPhone.errors.maxlength">
                      Phone number entered is too long. Please retry.
                    </div>
                    <div
                      *ngIf="userDetailsForm.contactPhone.errors.invalidphone"
                    >
                      Phone number entered is invalid. Please retry.
                    </div>
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="editor-phone-ext ml-1">
                  <mat-label>Ext</mat-label>
                  <input
                    type="tel"
                    matInput
                    formControlName="contactPhoneExt"
                    id="contactPhoneExt"
                    [readonly]="!userDetailsForm.contactPhone.value"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="invalid-feedback"
                *ngIf="
                  userDetailsForm.contactPhoneExt.invalid &&
                  (userDetailsForm.contactPhoneExt.dirty ||
                    userDetailsForm.contactPhoneExt.touched)
                "
              >
                <div *ngIf="userDetailsForm.contactPhoneExt.errors.pattern">
                  Only digits are accepted for phone extension. Please retry.
                </div>
                <div *ngIf="userDetailsForm.contactPhoneExt.errors.maxlength">
                  Phone extension entered is too long. Please retry.
                </div>
              </mat-error>
            </div>
          </div>
        </form>
        <div class="row section mt-3 py-2">
          <div class="col-2">
            <h4 class="form-label mt-3">PASSWORD</h4>
          </div>
          <div class="col py-2">
            <button
              class="button"
              mat-stroked-button
              [routerLink]="[Urls.PASSWORD_CHANGE]"
            >
              Change Password
            </button>
          </div>
        </div>
        <div class="row section mt-3">
          <div class="col">
            <div class="row">
              <div class="col-2">
                <h4 class="form-label mt-3">Role</h4>
              </div>
              <div class="col">
                <div class="my-3 pt-1">
                  @for (role of filteredRoles; track role) { @if
                  (hasAnyRole(userBehaviorSubject | async, [role])) {
                  <div
                    [ngClass]="{
                      'mb-3': role !== filteredRoles[filteredRoles.length - 1]
                    }"
                  >
                    {{
                      roleMapping.getRoleDisplayName(
                        roleMapping.getRoleEnum(role.name)
                      )
                    }}
                  </div>
                  } }
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      hasAnyRoleEnum(userBehaviorSubject | async, [
                        roleEnum.Admin
                      ]) &&
                      hasSiteSpecificRole(userBehaviorSubject | async) &&
                      (numSiteSelected$ | async) === 0
                    "
                  >
                    The user must have at least one site selected.
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row"
              *ngIf="hasSiteSpecificRole(userBehaviorSubject | async)"
            >
              <div class="col-2">
                <h4 class="form-label mt-3">Sites</h4>
              </div>
              <div class="col">
                <div class="mt-3 pt-1 font-weight-500">
                  {{
                    hasAnyRoleEnum(userBehaviorSubject | async, [
                      roleEnum.Admin
                    ])
                      ? 'Please select the sites you want to grant access to'
                      : 'Sites you have access to'
                  }}
                </div>
              </div>
            </div>
            <div
              class="row"
              *ngIf="hasSiteSpecificRole(userBehaviorSubject | async)"
            >
              <div class="col-2"></div>
              <div class="col pb-3">
                <app-site-permission-editor
                  *ngIf="
                    hasAnyRoleEnum(userBehaviorSubject | async, [
                      roleEnum.Admin
                    ])
                  "
                  [allSites]="sitesSource | async"
                  [triggerSitesRefresh]="triggerSitesRefresh$"
                  [defaultSite]="defaultSiteFormControl.value"
                  [permittedSiteIds]="permittedSites | async"
                  (sitePermissionChanged)="onSitePermissionChanged($event)"
                ></app-site-permission-editor>
                <app-site-permission-viewer
                  *ngIf="
                    !hasAnyRoleEnum(userBehaviorSubject | async, [
                      roleEnum.Admin
                    ])
                  "
                  [allSites]="sitesSource | async"
                  [triggerSitesRefresh]="triggerSitesRefresh$"
                  [defaultSite]="defaultSiteFormControl.value"
                  [permittedSiteIds]="permittedSites | async"
                  (defaultSiteChanged)="onDefaultSiteChanged($event)"
                ></app-site-permission-viewer>
              </div>
            </div>
            <div
              class="row"
              *ngIf="
                hasAnyRoleEnum(userBehaviorSubject | async, [roleEnum.Admin]) &&
                hasSiteSpecificRole(userBehaviorSubject | async)
              "
            >
              <div class="col-2">
                <h4 class="form-label mt-3">Default Site</h4>
              </div>
              <div class="col">
                <div class="mt-3">
                  <mat-form-field class="default-site-container editor">
                    <mat-label>{{
                      (sitesSource | async).length > 1 ? 'Select Site' : ''
                    }}</mat-label>
                    <mat-select
                      [formControl]="defaultSiteFormControl"
                      id="defaultSite"
                      [panelWidth]="null"
                    >
                      <mat-option [value]="0">No Default</mat-option>
                      <mat-option
                        *ngFor="
                          let sitePermissionInfo of selectedSites(
                            updatedSitePermission | async
                          )
                        "
                        [value]="sitePermissionInfo.siteInfo.siteId"
                      >
                        {{ sitePermissionInfo.siteInfo.siteName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div
              class="row pb-2"
              *ngIf="
                !hasAnyRoleEnum(userBehaviorSubject | async, [roleEnum.Admin])
              "
            ></div>
          </div>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col-2">&nbsp;</div>
          <div class="col">
            <div>
              <button
                type="button"
                class="button mr-3 everbtnwide"
                mat-stroked-button
                [disabled]="saving || loading"
                (click)="submit()"
              >
                Save
              </button>

              <button
                type="button"
                class="button everbtnplain everbtnwide"
                mat-stroked-button
                [disabled]="saving"
                (click)="reset()"
              >
                Reset
              </button>
              <mat-spinner *ngIf="saving" diameter="32">Saving...</mat-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
